// Notes are stored as plain newline-separated strings in the DB (one bullet per
// line). The UI works with string[] bullet lists, so we split on load and join
// on save. Blank/whitespace-only bullets are dropped both ways so they never
// persist and never render.

export const splitNotes = (value: string): string[] =>
    (value ?? '')
        .split('\n')
        .map((item) => item.trim())
        .filter((item) => item.length > 0);

export const joinNotes = (items: string[]): string =>
    items
        .map((item) => item.trim())
        .filter((item) => item.length > 0)
        .join('\n');
